import styled from 'styled-components';

export const StyledHealthcareOrganizationDataPanelOrganizationDetails = styled.div`
   display: grid;
   grid-template-columns: 1fr 431px;
   grid-template-rows: auto 1fr;
   grid-row-gap: 24px;
`;
StyledHealthcareOrganizationDataPanelOrganizationDetails.displayName =
   'StyledHealthcareOrganizationDataPanelOrganizationDetails';
